import request from "@/utils/request";

// 列表(主数据列表)
export function loadPaymentVoucherListDataApi(data) {
  return request({
    url: "web/paymentVoucher/listData",
    method: "post",
    data
  });
}
// 导出
export function loadPaymentVoucherExportDataApi(data) {
  return request({
    url: "web/paymentVoucher/exportData",
    method: "post",
    data
  });
}

// 操作
export function saveOrUpdatePaymentVoucherApi(data) {
  return request({
    url: "web/paymentVoucher/saveOrUpdate",
    method: "post",
    data
  });
}

// 查看
export function initPaymentVoucherApi(data) {
  return request({
    url: "web/paymentVoucher/init",
    method: "post",
    data
  });
}

// 待处理数量
export function countPaymentVoucherTodoNumberApi(data) {
  return request({
    url: "web/paymentVoucher/countTodoNumber",
    method: "post",
    data
  });
}

// 打印
export function printPaymentVoucherApi(data) {
  return request({
    url: "web/paymentVoucher/print",
    method: "post",
    data
  });
}
